import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";

// Force POST for all API calls (no GET/PUT/DELETE/PATCH)
if (typeof window !== "undefined" && window.fetch) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const isApi = url.includes("/api/");
    const currentMethod = (init?.method || (typeof input === "object" && input?.method) || "GET").toUpperCase();

    if (isApi && currentMethod !== "POST") {
      const nextInit = { ...init, method: "POST" };
      return originalFetch(input, nextInit);
    }
    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
